import React, { useState } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import { Row, Col } from "antd";
import CustomInfiniteScrollDiv from "../CustomInfiniteScrollDiv";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { capitalizeFirstLetter} from "../../../../helpers/utilities";

export const ClientListTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadMore, loadMoreTask, loadMoreContent } = props;
    const classes = customStyles();
    let cI = 0;
    const [selected, setSelected] = useState('');

    const handleClick = (id) => {
        if (selected === id) {
            setSelected('');
        } else {
            setSelected(id);
        }
    }

    return (
        <>
            <CustomInfiniteScrollDiv
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <div sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <div className={classes.loadMoreCircle}></div>
                                </div>
                            ) : (
                                <React.Fragment>
                                    {
                                        details.length > 0 && Array.isArray(details) && details.length > 0 ? details.map((data, i) => {
                                            if (cI === 3) {
                                                cI = 0;
                                            }
                                            cI += 1;
                                            return (
                                                <div onClick={(e) => handleClick(data.id)} className={clsx({ [classes.margin10t]: i > 0 }, { [classes.clientBgColor]: selected === data.id }, classes.PaddingRight15)} key={i}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <NavLink to={'#'} className={clsx(classes.businessName, classes.customLink, { [classes.businessGreenNameBorder]: cI === 3 }, { [classes.businessNameBorder]: cI === 2 })}>{data?.name}</NavLink>
                                                        </Col>
                                                    </Row>
                                                    <Row className={classes.clientPadding5} gutter={5}>
                                                        <Col span={6}>
                                                            <div className={clsx(classes.textFieldColor, classes.fonSize13, 'MuiInputLabel-shrink')}>{data?.serialNo}</div>
                                                            <div className={clsx(classes.textFieldColor, classes.fonSize14)}>{data?.country?.name || '---'}</div>
                                                        </Col>
                                                        <Col span={8}>
                                                            <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink')}>Phone</div>
                                                            <div className={clsx(classes.textFieldColor, classes.fonSize14)}>{data?.mobile || '---'}</div>
                                                        </Col>
                                                        <Col span={6}>
                                                            <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink')}>Type</div>
                                                            <div className={clsx(classes.textFieldColor, classes.fonSize14)}>{data?.customerType ? capitalizeFirstLetter(data?.customerType) : '---'}</div>
                                                        </Col>
                                                        <Col span={4}>
                                                            <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.textAlignRight)}>Paid</div>
                                                            <div className={clsx(classes.textFieldColor, classes.fonSize14, classes.textAlignRight)}>No</div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        }) : <div> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></div>
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}